// src/components/InitialRedirect.tsx
import { Navigate } from "react-router-dom";

const InitialRedirect = () => {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');

    // Verificar si tiene permiso para ver el dashboard de claims
    if (permissions.includes('CLAIMS.VIEW')) {
        return <Navigate to="/claims/dashboard" replace />;
    }

    // Si no tiene CLAIMS.VIEW, verificar si tiene permiso para ver el dashboard global
    if (permissions.includes('SURVEYS_PATIENTS.VIEW')) {
        return <Navigate to="/survey-patient/dashboard" replace />;
    }

    if (permissions.includes('SURVEY_UPLOAD.VIEW')) {
        return <Navigate to="/survey-load" replace />;
    }

    if (permissions.includes('IMPROVEMENT_PLANS.VIEW')) {
        return <Navigate to="/improvement-plans" replace />;
    }

    if (permissions.includes('ALERTS.VIEW')) {
        return <Navigate to="/alertes" replace />;
    }

    if (permissions.includes('ADMINISTRATION.VIEW')) {
        return <Navigate to="/admin" replace />;
    }
    // Si no tiene ninguno de los permisos, redirigir a una p�gina de acceso denegado o login
    return <Navigate to="/" replace />;
};

export default InitialRedirect;
